export default __webpack_public_path__ + "static/media/insights-landing-why.65c00c27.svg";